module.exports = __webpack_public_path__ + "08bde2c6416732ec2200564ff6e2550e.png";